import { CheckCircleTwoTone } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';

import type {
  ColumnType,
  GetColumnsProps,
  MonthData,
} from '@app/pages/Users/UserProfile/components/SalaryInfo/types';
import { divideAmount } from '@app/utils';

const { Text } = Typography;

export const getColumns = ({
  confirmed,
  openConfirmModal,
}: GetColumnsProps): ColumnType[] => {
  return [
    {
      title: '',
      dataIndex: 'month',
      key: 'month',
      render: (value) => <Text>{value as string}</Text>,
    },
    {
      title: '',
      dataIndex: 'amount',
      key: 'amount',
      render: (value) => <Text strong>{divideAmount(value)}</Text>,
    },
    {
      title: '',
      key: 'action',
      render: (_, record?: MonthData) =>
        record && confirmed[record.key] ? (
          <Tooltip title="Подтверждено">
            <Text type="success" style={{ cursor: 'pointer' }}>
              <CheckCircleTwoTone twoToneColor="#52c41a" />
            </Text>
          </Tooltip>
        ) : record ? (
          <Button type="link" onClick={() => openConfirmModal(record.key)}>
            Подтвердить
          </Button>
        ) : null,
    },
  ];
};
